/*
*
* Be extremely cautious by using this cache.
* Please contact Platform (AIE) Team if you plan using it.
*
*/

import { RequestContext }  from '../types/request-context';

export const regionRegex = /\/region\/(na|fe|eu)($|\/|\?)/

export const getKeyUnrecognizedCustomer = (context: RequestContext, additionalFields?: Array<keyof RequestContext>) => {
  const region = context.originalURI ? context.originalURI.match(regionRegex) : null
  let fields = ''
  if(additionalFields) {
    fields = additionalFields.reduce((acc, val) => acc += context[val], '')
  }
  return `${region ? region[1] : ''}-${context.locale}-${context.domain}-${fields}`
}

interface CacheProps {
  limit?: number,
  ttl?: number
}

export class Cache {
  limit: number
  ttl: number
  cache: {
    [key: string]: any
  }
  capacity: number

  constructor({ limit = 50, ttl = 60 }: CacheProps = {}) {
    this.limit = limit
    this.ttl = ttl * 1000
    this.cache = {}
    this.capacity = 0
  }

  outdated(timestamp: number, key: string) {
    const isOutdated = (Date.now() - timestamp) > this.ttl
    if(isOutdated) {
      this.del(key)
    }
    return isOutdated
  }

  get(key: string) {
    if(!key || !this.cache[key] || this.outdated(this.cache[key].timestamp, key)) {
      return null
    }
    return this.cache[key].data
  }

  put(key: string, data: any) {
    if(this.cache[key]) {
      this.del(key)
    }

    if(this.capacity + 1 > this.limit) {
      this.prune()
    }

    this.cache[key] = {
      timestamp: Date.now(),
      data
    }

    this.capacity++
  }

  del(key: string) {
    if (this.cache.hasOwnProperty(key)) {
      delete this.cache[key]
      this.capacity--
    }
  }

  prune() {
    if (this.capacity) {
      this.del((Object.keys(this.cache)[0] as string))
    }
  }

  clear() {
    for (const key in this.cache) {
      if (this.cache.hasOwnProperty(key)) {
        this.del(key)
      }
    }
    this.cache = {}
  }
}
